import React from "react";
import Footer_En from '../Components/Footer_En'
import NaviBarv2_En from '../Components/NaviBarv2_En'
import 'bootstrap/dist/css/bootstrap.min.css';
import "../styles.css";
import {Container} from 'react-bootstrap';
import Sirius_conference from "../images/conf/Sirius_conference.png"


export function Conf_mathematicsAI_En () {
  return (
        <>
    <NaviBarv2_En />
    <Container>
    <div><img src={Sirius_conference} align="left" width={500} alt="Conference" /></div>
    <div className="row my-4 ps-4"><h2>Scientific conference «Mathematics of Artificial Intelligence».</h2></div>
    <div className="row ps-4 my-4"><p className="lead"></p></div>
    <div className="row ps-4 my-4"><p className="lead"></p></div>
    <div className="row ps-4 my-4"><p className="lead"></p></div>
    <hr />
    <div className="row ps-4 my-4"><p className="lead">The goal of the conference is to create a unique platform for the exchange of opinions and ideas among leading experts in mathematics and theoretical programming, in order to form a formal basis for such key trends in the development of intelligent software systems as: <br />
    - trusted artificial intelligence;<br />
    - explainable artificial intelligence;<br />
    - hybrid artificial intelligence;<br />
    - large language models.
    </p></div>
    <div className="row ps-4 my-4"><p className="lead">The conference is devoted to new mathematical methods and approaches for artificial intelligence systems. Building strong artificial intelligence requires new breakthrough mathematical solutions, especially when it comes to training intelligent systems.</p></div>
    <div className="row ps-4 my-4"><h3>Organizing committee:</h3></div>
    <div className="row ps-4 my-4"><p className="lead"><b>Ivan Oseledets – </b> Skoltech<br />
    <b>Denis Turdakov – </b> ISP RAS <br />
    <b>Andrey Nechesov – </b> NSU &amp; Sobolev Institute of Mathematics SB RAS <br />
    <b>Sergey Strizhak – </b> ISP RAS <br />
    <b>Igor Anureev – </b> IIS SB RAS &amp; NSU <br />
    <b>Dmitry Kondratyev – </b> IIS SB RAS &amp; NSU <br />
    <b>Vitaly Kazakov – </b> NSU <br />
    <b>Ivan Bondarenko – </b> NSU <br />
    <b>Sergey Novikov – </b> NSU <br />
    </p></div>

    <div className="row ps-4 my-4"><h3>Program committee:</h3></div>
    <div className="row ps-4 my-4"><p className="lead"><b>Ivan Oseledets – </b> Skoltech<br />
    <b>Denis Turdakov – </b> ISP RAS <br />
    <b>Andrey Nechesov – </b> NSU &amp; Sobolev Institute of Mathematics SB RAS <br />
    <b>Sergey Strizhak – </b> ISP RAS <br />
    <b>Igor Anureev – </b> IIS SB RAS &amp; NSU <br />
    <b>Dmitry Kondratyev – </b> IIS SB RAS &amp; NSU <br />
    <b>Sergey Goncharov – </b> Sobolev Institute of Mathematics SB RAS &amp; NSU <br />
    <b>Ivan Bondarenko – </b> NSU <br />
    <b>Evgeny Vityaev – </b> Sobolev Institute of Mathematics SB RAS &amp; NSU <br />
    <b>Andrey Mantsivoda – </b> ISU <br />
    <b>Denis Ponomaryov – </b> IIS SB RAS <br />
    <b>Dmitry Sviridenko – </b> NSU <br />
    </p></div>

    <div className="row ps-4 my-4"><p className="lead">More detailed information is available on the <a rel="noopener" target="_blank" href="https://siriusmathcenter.ru/055w">conference website</a>.</p></div>
    <div className="row ps-4 my-4"><p>13.02.2025</p></div>
    </Container>
    <Footer_En />
    </>

    )}
